import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { sendQueryAsset } from '@api/assets';

import { ESnackbarTypes } from '@enums/common';

import { QUERY_ASSET } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSendQueryAsset = (closeModal?: () => void) => {
	const dispatch = useAppDispatch();

	const { isLoading: isSendingQueryAsset, mutate } = useMutation({
		mutationKey: [QUERY_ASSET],
		mutationFn: sendQueryAsset,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.sendQueryAsset,
				type: ESnackbarTypes.success,
			}));

			if (closeModal) closeModal();
		},
	});

	return {
		isSendingQueryAsset,
		sendQueryAsset: mutate,
	};
};
